import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { LicenseInfo } from '@mui/x-license';
import * as Sentry from '@sentry/react';

import { env } from '../common/lib/env';
import { initSentry, sentryRootOptions } from '../common/lib/sentry';

import { App } from './components/App';
import { store } from './store';

import '../common/css/index.css';

// Session replay, uploaded only when an error is captured. Text/media masked by default.
initSentry(env.sentryDsnPortal, [Sentry.replayIntegration()]);

// Allowed to be exposed
// https://mui.com/x/introduction/licensing/#license-key-security
LicenseInfo.setLicenseKey(env.muiLicenceKey);

ReactDOM.createRoot(document.getElementById(`root`) as HTMLElement, sentryRootOptions).render(
  <Provider store={ store }>
    <App />
  </Provider>,
);
